import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type InventoryReportSearch,
  inventoryReportSearchFrom,
} from '@/features/inventory-analysis/api'
import { ReplenishmentReportScreen } from '@/features/inventory-analysis/replenishment-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/replenishment')({
  validateSearch: (search: Record<string, unknown>): InventoryReportSearch =>
    inventoryReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: ReplenishmentReportRoute,
})

function ReplenishmentReportRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <ReplenishmentReportScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/inventory/reports/replenishment', search: next })
      }
    />
  )
}
